import { render } from "./RaceRewardsComponent.vue?vue&type=template&id=098d379e"
import script from "./RaceRewardsComponent.vue?vue&type=script&lang=js"
export * from "./RaceRewardsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__